<template>
  <div class="notice-global" :class="`notice-global_${type}`">
    <div class="notice-global__text-block">
      <slot name="text" />
      <div class="notice-global__buttons">
        <Button
          v-if="commonActionButtonText"
          :title="commonActionButtonText"
          :type="EButtonType.secondary"
          :size="ESize.small"
          invert
          @click="$emit('clickCommonActionButton')"
        />
        <Button
          v-if="additionalActionButtonText"
          :title="additionalActionButtonText"
          :type="EButtonType.secondary"
          :size="ESize.small"
          invert
          @click="$emit('clickAdditionalActionButton')"
        />
      </div>
    </div>
    <div class="notice-global__right-controls">
      <CloseSvg
        v-if="closable"
        class="notice-global__close-icon"
        @click="$emit('close')"
      />
      <template v-else-if="moreLink">
        <Button
          :title="tt('shared.action.moreDetailed')"
          :type="EButtonType.link"
          :size="ESize.small"
          invert
          @click="handleRedirectButton"
        >
          <template #icon>
            <InfoHintSvg />
          </template>
        </Button>
      </template>
    </div>
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  PropType,
} from 'vue';

import {
  EButtonType,
  ENoticeType,
  ESize,
} from '@/ui/types';
import Button from '@/ui/Button/index.vue';
import CloseSvg from '@/assets/svg/16x16/close.svg';
import InfoHintSvg from '@/assets/svg/16x16/info-hint.svg';
import tt from '@/i18n/utils/translateText';

export default defineComponent({
  name: 'NoticeGlobal',
  components: {
    Button,
    CloseSvg,
    InfoHintSvg,
  },
  props: {
    type: {
      type: String as PropType<ENoticeType>,
      default: ENoticeType.neutral,
    },
    commonActionButtonText: {
      type: String,
      default: '',
    },
    additionalActionButtonText: {
      type: String,
      default: '',
    },
    /* По задумке дизайнеров у нас может быть либо кнопка закрытия, либо кнопка Подробнее, либо ничего,
        одновременного отображения обеих кнопок не заложено.
        В случае если передать и closable, и moreLink отобразится только кнопка закрытия. */
    closable: {
      type: Boolean,
      default: false,
    },
    moreLink: {
      type: String,
      default: '',
    },
  },
  emits: ['clickCommonActionButton', 'clickAdditionalActionButton', 'close'],
  setup(props) {
    const handleRedirectButton = () => {
      const isLinkRelative = props.moreLink.startsWith('/');

      // Если указана относительная ссылка, например, /docs/default/privacy.pdf
      if (isLinkRelative) {
        window.open(`${import.meta.env.VITE_APP_HOST}${props.moreLink}`, '_blank');
        // Если указана абсолютная ссылка, например, https://www.google.com/
      } else {
        window.open(props.moreLink, '_blank');
      }
    };
    return {
      EButtonType,
      ESize,

      handleRedirectButton,
      tt,
    };
  },
});
</script>

<style lang="scss" src="./styles.scss" />
